//do we migrate this to ./src/components/utils/fileupload

const postFetch = (params) => {
    console.log(`postFetch`, params);
    return fetch(
        window.location,
        {
            method: "POST",
            headers: {
                'Content-Type': "application/x-www-form-urlencoded; charset=UTF-8",
            },
            body: new URLSearchParams(params).toString()                
        }
    ).then( async (response) => await response.json() );
}

const uploadFile = (url, file, params) => new Promise(
    (resolve, reject) => { 
        var xhr = new XMLHttpRequest();
        var formData = new FormData();
    
        var fields = params ? params : {};
    
        for(var x in fields) {
            formData.append(
                x,
                fields[x]
            );
        }
    
        formData.append('file', file);
    
        xhr.onreadystatechange = function(e) 
        {
            if (xhr.readyState == 4) 
            {
                resolve();
            }
        };

        xhr.onerror = reject;
    
    
        xhr.open('POST', url, true);
        xhr.send(formData);
    }
);

const requestUploadSlotV1 = (url, params) => postFetch({
    global: true,
    _ajax: true,
    type: "request",
    post: "upload",
    url: url
}).then( (response) => {
    return response.url 
});

const requestUploadSlotV2 = (url, params) => postFetch({
    _ajax: true,
    global: true,
    type: "request",
    post: "uploadV2",
    url,
    paramString: JSON.stringify(params)
}).then( (response) => response.payload )

const uploadFileV2 = (
    file,
    hash,
    uploadType,
    extraParams
) => async () => {
    const slot = await requestUploadSlotV2(
        '',
        Object.assign(
            {
                hash: hash,
                uploadType: uploadType,
                fileName: file.name,
            },
            extraParams ? extraParams : {}
        )
    ).catch( () => false );

    if(!slot) {
        throw 'Failed to obtain upload url.';
    }

    const fileUploadResult = await uploadFile(slot.url, file, slot.fields).catch( () => false );

    if(!fileUploadResult) {
        throw 'Failed to upload file.';
    }

    return slot;
}

export {
    requestUploadSlotV1,
    requestUploadSlotV2,
    uploadFileV2
};